import React from 'react';
import { motion } from 'framer-motion';
export function RefundPolicyPage() {
  return <main className="flex-1 bg-background" data-id="element-369">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-370">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-371">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-372">
            Refund Policy
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-373">
            Our refund policy is designed to be fair and transparent.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white" data-id="element-374">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-375">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-12" data-id="element-376">
            <div data-id="element-377">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-378">
                Tiered Refund Structure
              </h2>
              <ul className="space-y-4 text-lg text-slate-600 leading-relaxed list-disc pl-6" data-id="element-379">
                <li data-id="element-380">
                  <strong className="text-slate-800" data-id="element-381">0–14 Days:</strong> Full
                  refund available if no ebooks have been accessed or read.
                </li>
                <li data-id="element-382">
                  <strong className="text-slate-800" data-id="element-383">15–28 Days:</strong>{' '}
                  Partial refund may be offered at our discretion, based on your
                  usage history and circumstances.
                </li>
                <li data-id="element-384">
                  <strong className="text-slate-800" data-id="element-385">After 28 Days:</strong>{' '}
                  Refunds are typically not available, except in cases of proven
                  technical failure of our service.
                </li>
              </ul>
            </div>

            <div data-id="element-386">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-387">
                Refund Method
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-388">
                All approved refunds will be returned to the original payment
                method used for the purchase (processed via Stripe). We cannot
                issue refunds to a different card or bank account.
              </p>
            </div>

            <div data-id="element-389">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-390">
                Processing Time
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-391">
                Once a refund is approved, please allow 5-10 working days for
                the funds to appear in your account, depending on your bank's
                processing times.
              </p>
            </div>

            <div data-id="element-392">
              <h2 className="text-2xl font-bold text-slate-dark mb-4" data-id="element-393">
                Exceptions
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-394">
                Refunds may be denied if we detect a violation of our Terms &
                Conditions, or if there is evidence of excessive usage (e.g.,
                accessing a large volume of content) prior to the refund
                request.
              </p>
            </div>

            <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-395">
              <h2 className="text-xl font-bold text-slate-dark mb-2" data-id="element-396">
                How to Request a Refund
              </h2>
              <p className="text-slate-600" data-id="element-397">
                To request a refund, please email{' '}
                <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-398">
                  manishhoran123@gmail.com
                </a>{' '}
                with your order details and the reason for your request. Our
                team will review your case and respond within one working day.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </main>;
}